export default "__VITE_ASSET__49bce1bc__"